// extracted by mini-css-extract-plugin
export default {"labelRoot":"ActionLabel_labelRoot__QnEx9","clicker":"ActionLabel_clicker__ebxBe"};